var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 220,
    viewBox: "0 0 1280 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-232.921 204.425C-232.921 204.425 -233.46 203.472 -234 203.472C-126.05 138.166 28.8585 76.6736 195.102 71.9067C361.345 63.8031 529.207 110.995 672.241 174.394C813.656 237.317 930.242 316.923 1024.16 358.395C1118.61 401.773 1202.28 407.494 1280 361.732C1279.46 362.208 1278.92 363.162 1277.84 364.115C1200.12 410.83 1116.46 405.587 1022.54 362.208C929.162 320.737 813.116 241.13 671.701 177.731C528.667 113.855 361.345 66.6632 195.102 74.2902C29.3982 78.5803 -125.51 139.596 -233.46 204.425H-232.921Z",
    fill: "#149C84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1293.04 157.561C1293.04 157.561 1293.52 156.868 1294 156.522C1177.88 72.669 1026.58 15.15 869.99 3.369C712.431 -10.491 555.836 20.001 414.66 65.739C275.893 111.13 154.954 173.847 60.0334 215.427C-36.3326 258.393 -115.353 279.183 -191 270.52C-190.518 270.867 -190.036 271.56 -189.555 271.906C-113.907 280.915 -34.8871 260.472 60.9971 217.852C155.436 176.272 276.375 113.556 414.66 67.818C555.355 22.08 711.949 -8.412 869.508 5.10149C1026.58 16.8825 1177.4 73.7085 1293.04 157.215V157.561Z",
    fill: "#149C84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingLines);
export default __webpack_public_path__ + "static/media/landingLines.83809d68450af632762dd8613bb4d557.svg";
export { ForwardRef as ReactComponent };